import { render } from "./TextFile.vue?vue&type=template&id=f577ee26"
import script from "./TextFile.vue?vue&type=script&lang=js"
export * from "./TextFile.vue?vue&type=script&lang=js"
script.render = render

export default script